import { render } from "./exchangeOrder.vue?vue&type=template&id=2babe828&scoped=true"
import script from "./exchangeOrder.vue?vue&type=script&lang=js"
export * from "./exchangeOrder.vue?vue&type=script&lang=js"

import "./exchangeOrder.vue?vue&type=style&index=0&id=2babe828&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2babe828"]])

export default __exports__